// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notificar la redirección del cliente",
  "1d484fee4a": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos, Datos de Negocio, Departamento de Productos, Departamento de Operaciones, Gestión de Investigación y Desarrollo, Plan de Versiones, Departamento de Servicio al Cliente, Departamento de Administración, Departamento de Compras, Gestión de Soporte Técnico",
  "a2c88dfb79": "Crea tu primer equipo",
  "3cfdcc6086": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos/305, Administración y Recursos Humanos/306, Departamento de Operaciones, Gestión de Investigación y Desarrollo, Plan de Versiones, Gestión de Servicio al Cliente/403, Departamento de Compras, Gestión de Soporte Técnico",
  "ac45ec2c05": "La verificación del inicio de sesión de la cuenta ha fallado",
  "9aef9b8ccd": "La cuenta actual de inicio de sesión es anómala. Intente nuevamente después de iniciar sesión en la cuenta",
  "728dd00f22": "La verificación del número de teléfono móvil es anómala. Intente iniciar sesión con el código de verificación de mensaje de texto",
  "30dbecd916": "La información que has ingresado contiene palabras sensibles. Por favor, modifíquela e inténtelo de nuevo",
  "12ed508d8a": "Tu operación es demasiado frecuente. Inténtalo de nuevo más tarde",
  "952d4a7595": "El estado de inicio de sesión de la cuenta actual es anómalo. Intente nuevamente después de iniciar sesión en la cuenta",
  "e64bfdeaa4": "La verificación de inicio de sesión ha fallado. Obtenga de nuevo el código de verificación de mensaje de texto",
  "79008a65f1": "Este número de teléfono móvil se ha unido a varias empresas. Inicie sesión en la empresa o cambie el número de teléfono móvil",
  "bf242eff42": "El nombre de la empresa ya existe",
  "4f0cdb8374": "Ingrese el número de teléfono móvil completo. Si utiliza un número de teléfono móvil extranjero, cambie a un número nacional (86+)",
  "46e79ffeff": "La creación de la empresa es anómala. Comuníquese con el servicio de soporte oficial para resolverlo",
  "f3e18f0341": "La verificación de los parámetros ha fallado",
  "503fd1718d": "El envío del código de verificación de mensaje de texto ha fallado",
  "24b3129f19": "El envío de mensajes de texto es demasiado frecuente. Inténtalo de nuevo más tarde",
  "1cde3e8245": "El código de verificación es incorrecto. Ingrese nuevamente",
  "4212ecc031": "Se ha verificado erróneamente varias veces. La verificación está temporalmente restringida. Inténtalo de nuevo más tarde",
  "735da9c347": "La verificación de nombre repetido de la empresa es anómala. Comuníquese con el servicio de soporte oficial para resolverlo",
  "8731da9615": "La verificación de la certificación del nombre de la empresa es anómala. Comuníquese con el servicio de soporte oficial para resolverlo",
  "62e89b3f16": "Aceptar el Acuerdo de Servicio",
  "c9b79027e5": "Enviar código de verificación",
  "84c1447b9d": "Copia exitosa",
  "fba4b0abd0": "Registro del host",
  "37f5a7cd41": "Valor de TXT",
  "78b12427c9": "En certificación...",
  "59d089837c": "Actualmente no podemos verificar tu dominio. Es posible que necesites esperar un tiempo más para que el proveedor de alojamiento de dominios actualice tu información. Si después de un tiempo no hay respuesta, intenta verificar de nuevo o cambia el dominio.",
  "4a5b7383d1": "Verificando el dominio",
  "f24a492e40": "de los registros de verificación. Puedes cerrar esta página y volver más tarde para revisar.",
  "c697ca5f1a": "Bienvenido al uso de la versión empresarial",
  "ebb01b1740": "Siguiente",
  "30109bf753": "¿Tu empresa tiene un dominio?",
  "2b3e485b47": "Tengo un dominio empresarial",
  "1a7f5eae44": "No tengo un dominio empresarial",
  "bde15d6d84": "Debes tener un dominio (por ejemplo, example.com) para crear una cuenta empresarial para ti",
  "07ffb22c90": "Lo siento, debes tener un dominio para crear una cuenta empresarial para tu empresa",
  "de23836563": "Ingrese el dominio para crear una cuenta empresarial",
  "287c07944a": "Verificar tu dominio",
  "3ea2d528d5": "Siga los siguientes pasos para demostrar que eres el propietario de <b>{domain}</b> y evitar que cualquier otra persona registre una cuenta empresarial con este dominio.",
  "082b18ce56": "a. Abra el sitio web del proveedor de alojamiento de dominios en una <b>nueva pestaña</b> y luego <b>inicie sesión</b> en su cuenta;",
  "4f7e0841a9": "b. En el sitio web del proveedor de alojamiento de dominios, vaya a la <b>sección de registros DNS</b>. En la página web de su proveedor de alojamiento de dominios, el nombre de la sección de registros DNS puede variar, por ejemplo, se muestra como <b>DNS Management (Administración de DNS), Name Sever Management (Administración de servidores de nombres), Control Panel (Panel de control) o Advanced Setting (Configuración avanzada).</b>",
  "6365ad6e3a": "A continuación, <b>vuelva aquí</b> y haga clic en 「Siguiente」 para agregar un registro de verificación.",
  "8528892080": "Agregar registro de verificación",
  "7a225304f8": "a. En la página DNS, desplácese hacia la <b>sección TXT</b> y luego haga clic en el botón correspondiente para agregar un registro;",
  "b3cb7d947c": "b. <b>Copie y pegue</b> todos los valores siguientes en el <b>formulario TXT</b> del sitio web del proveedor de alojamiento de dominios;",
  "47213583bf": "c. Guarde los registros en el sitio web del proveedor de hospedaje de dominios, <br>luego regrese aquí y haga clic en 'Verificar dominio' debajo.",
  "21486a57cf": "Nota: En el campo de nombre/anfitrión/alias, puede ingresar '@' o dejarlo en blanco. El proveedor de hospedaje de dominios también puede solicitar que ingrese el dominio (<su dominio>.com) en este campo. Tal vez pueda determinar cómo llenar este campo en función de otros registros DNS. En el campo de tiempo de vida (TTL), ingrese '86400' o mantenga el valor predeterminado.",
  "f1b8edab9c": "Cambiar dominio",
  "7c6fc663a8": "Verificar dominio",
  "b6aee9dc0d": "Verificación de dominio exitosa",
  "dd4cc429ea": "Se ha demostrado que eres",
  "450f5c9230": "el propietario de y se prohíbe a cualquier otra persona utilizar este dominio para registrar una cuenta empresarial.",
  "71cbcba755": "Haga clic en 'Siguiente' para completar la creación de la cuenta empresarial.",
  "f4084f4870": "Establezca su cuenta de inicio de sesión",
  "fe3138baec": "Completar creación",
  "0315cddedb": "Creación de empresa exitosa",
  "91454a7f34": "Ahora, inicie sesión en el panel de administración para crear cuentas empresariales para los miembros de su empresa.",
  "366304cde7": "1. Se cerrará automáticamente la sesión de la cuenta de WPS actual.",
  "8a9f2a8422": "2. Debe usar la cuenta empresarial {account}@{domain} para iniciar sesión en el panel de administración.",
  "43e265e998": "Ir al panel de administración",
  "9240efaaf0": "Mensaje de texto enviado",
  "e424bb9a6d": "Ingrese",
  "d44d581706": "Nombre de la empresa",
  "aa8679f406": "entre 4 y 30 caracteres",
  "581bdb1f98": "no puede contener símbolos especiales \\/:*?\"<>|{}",
  "c13cabb67a": "Correo electrónico",
  "2b9b429e46": "Su correo electrónico",
  "5ed834a7df": "Ingrese su correo electrónico",
  "acfd1f02ed": "Ingrese un correo electrónico correcto",
  "31c7c92cca": "máximo 80 caracteres",
  "3f27cf84b3": "Ingrese el código de verificación",
  "a0ae1f3ec4": "Código de verificación incorrecto",
  "e5589c5e74": "Su nombre",
  "69d7bd63f6": "solo se permiten caracteres chinos, letras y números",
  "91f008d258": "máximo 8 caracteres",
  "6ea6c9b39b": "Teléfono de contacto",
  "161042c5b7": "Ingrese el teléfono de contacto",
  "e6b8eab1cd": "Ingrese el teléfono de contacto, 11 dígitos",
  "3fd5fbb3cc": "Ingrese su dominio",
  "cb5346ba8e": "Ingrese el dominio empresarial correcto, entre 4 y 30 caracteres",
  "27928eb7a4": "Cuenta",
  "8e19bd444d": "Ingrese el nombre de cuenta para iniciar sesión",
  "7bbbf479dc": "entre 4 y 20 caracteres, solo dígitos, letras o guiones bajos",
  "3d84cae479": "Ingrese una cuenta que cumpla con los requisitos / El primer carácter debe ser una letra o un número",
  "c0d5ece1a7": "Contraseña",
  "f444036fa8": "Ingrese la contraseña",
  "b03218d72b": "La contraseña debe tener 12 a 16 letras mayúsculas y minúsculas, números o combinaciones de 3 caracteres especiales",
  "b4ab05df50": "*Alguien en su organización ya está utilizando su dominio para una cuenta empresarial. Comuníquese con el servicio de atención al cliente (400-677-5005) para demostrar que es dueño de este dominio.",
  "c58876008f": "La copia ha fallado. Inténtelo de nuevo.",
  "86f73420de": "Enlace de invitación",
  "a58861962c": "Lo siento, su navegador actual no admite la descarga de este código QR",
  "228db07f78": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos, Datos de Negocio, Departamento de Productos, Departamento de Operaciones, Gestión de Investigación y Desarrollo, Planificación de Versiones, Departamento de Servicio al Cliente, Departamento de Administración, Departamento de Compras, Gestión de Soporte Técnico",
  "93896d7e98": "Después de crear un equipo, empiece a colaborar con sus colegas",
  "e8f66fb75c": "Departamento de Finanzas, Departamento de Ventas, Gestión de Proyectos/305, Administración y Recursos Humanos/306, Departamento de Operaciones, Gestión de Investigación y Desarrollo, Planificación de Versiones, Gestión de Servicio al Cliente/403, Departamento de Compras, Gestión de Soporte Técnico",
  "831b73da9b": "El nombre no puede contener caracteres ilegales y símbolos especiales /\\;:*?\"<>|%&",
  "51ab33b3ee": "Los parámetros no son correctos",
  "a297f9e951": "El nombre de la empresa está duplicado",
  "04d60ed5f5": "No se pueden usar palabras prohibidas",
  "2ff7bef083": "El formato del dominio es incorrecto",
  "41e1ba2165": "La verificación de la información TXT del dominio ha fallado",
  "50f348caa9": "La cuenta está duplicada",
  "9d4c950d65": "Este nombre ya está en uso",
  "38cf19ed95": "Este nombre de institución ya existe",
  "4b426e7c9c": "Nombre de la institución",
  "298f880e18": "Ya existe. Le recomendamos que agregue más información:",
  "1e67dd20b3": "Recuperar el nombre de la institución",
  "517107cb04": "Usar otro nombre",
  "5667081882": "Crear con este nombre",
  "e306a979a6": "Llenado rápido:",
  "f583db96e0": "*Si el nombre de la institución está ocupado, puede",
  "9767148e34": "Ingrese el nombre de la empresa u organización, entre 4 y 100 caracteres",
  "e0e0ec159f": "Nombre de la institución",
  "5b13d254c0": "Este nombre de empresa ya existe",
  "92027671ec": "Nombre de la empresa",
  "36d482a7fb": "Recuperar el nombre de la empresa",
  "79058a7577": "*Si el nombre de la empresa está ocupado, puede",
  "c96dd48dba": "Nombre de la empresa",
  "842efad336": "*Si es un empleado de la empresa, por favor",
  "860f9bd77b": "Contactar al servicio de atención al cliente",
  "5a7ed18daf": "Unirse a la empresa",
  "ab470e9ace": "Información de contacto reservada",
  "0a7e0e48a7": "Nombre de la empresa a la que se solicita unirse:",
  "a8dc318dcc": "Verifique la información de contacto que ha ingresado. El servicio de atención al cliente de la plataforma le llamará pronto.",
  "6ea1f4d7f5": "Enviar datos",
  "d439e39f43": "Hemos recibido sus datos",
  "884653426b": "El servicio al cliente le llamará en las próximas 24 horas. ¡Por favor, tenga en cuenta de atender la llamada!",
  "2361cb14bf": "Escanee el código QR de WeChat para agregar el servicio al cliente en línea y conocer el progreso",
  "50f45d0031": "La operación de guardar ha fallado",
  "fc856d0fd2": "Super administrador",
  "e16c0676d2": "Administrador",
  "b1d2ddd126": "Miembro común",
  "9d322cc08d": "El nombre de la institución no puede contener símbolos especiales \\/:*?\"<>|{}",
  "b583ba7363": "El nombre de la empresa no puede contener símbolos especiales \\/:*?\"<>|{}",
  "1d118a9bad": "El nombre de la institución debe tener al menos 4 caracteres. Ingrese un nombre de institución de 4 a 100 caracteres",
  "441b45b1f5": "El nombre de la empresa debe tener al menos 4 caracteres. Ingrese un nombre de empresa de 4 a 100 caracteres",
  "97457cb1f0": "El nombre de la institución ha excedido los 100 caracteres. Ingrese un nombre de institución de 4 a 100 caracteres",
  "8ce00d3b92": "El nombre de la empresa ha excedido los 100 caracteres. Ingrese un nombre de empresa de 4 a 100 caracteres",
  "a72778d3de": "El nombre debe tener al menos 2 caracteres. Ingrese un nombre de 2 a 10 caracteres",
  "79c17db5de": "El nombre ha excedido los 10 caracteres. Ingrese un nombre de 2 a 10 caracteres",
  "482a118202": "El nombre solo admite caracteres chinos, números, letras inglesas y ·",
  "9a9be18941": "Por favor, marque la casilla",
  "e6b7c4aa66": "Acuerdo de servicio en línea",
  "595023d905": "Crear institución",
  "ba8c2df551": "Crear empresa",
  "d284384975": "Acuerdo de servicio en línea",
  "5c266d5a84": "Acuerdo de privacidad",
  "fcb92dbcf6": "Acuerdo de servicio de oficina en la nube",
  "2ae7a8a3f7": "Gracias por elegir el servicio de oficina en la nube WPS 365. A continuación, se presenta principalmente el acuerdo legal sobre el registro, la suscripción y el uso de este servicio alcanzado entre usted y/o el organismo que representa y Kingsoft Office.",
  "d30a6983bd": "Por favor, lea {0} | {1} | {2} y haga clic en 'Aceptar'. Al hacerlo, se considerará que acepta el contenido del acuerdo y acepta nuestro servicio.",
  "263e306ede": "He leído y acepto {0} | {1} | {2}",
  "440129c0f1": "Por favor, ingrese {0}",
  "8ab916983d": "Nombre de la empresa",
  "b01d68543b": "Su nombre",
  "684b30d4e9": "Su número de teléfono móvil",
  "a48427e8e2": "Utilizado para crear una plataforma de trabajo para su empresa",
  "3a81b0f1fc": "Facilita que sus colegas lo encuentren en el sistema y trabajen en colaboración",
  "52bc539b6e": "Confirmar creación",
  "b2fe245e19": "Crear empresa/equipo: Compartir y colaborar archivos",
  "893282d3f7": "Por favor, complete la información de la empresa:",
  "cc997bf6aa": "Confirmar",
  "50fdde51ac": "{0}, {1} a {2} dígitos",
  "a19cc5ec18": "{0}, no puede contener símbolos especiales \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, solo se permiten caracteres chinos, letras y números",
  "f4080b1431": "{0}, máximo {1} dígitos",
  "88e59b2d58": "{0}, 11 dígitos numéricos",
  "91d6d4e105": "Ingrese el código de verificación",
  "bec71bde96": "El código de verificación no es correcto",
  "e20ff8ee19": "{0} es obligatorio",
  "8dc09d10d7": "No se encontró el dwId",
  "a03766ce6c": "Escuela",
  "03542addfe": "Empresa",
  "adb8a815d1": "El límite de enlaces de número de teléfono móvil con {0} se ha alcanzado",
  "97a6b66f1d": "El número de teléfono móvil actual está enlazado a {0}",
  "665e465487": "No se puede crear {0}, el número de teléfono móvil actual “<strong>{1}</strong>” ha alcanzado el límite de enlaces con {0} (se pueden enlazar como máximo 5 {2}), puede acceder a los {3} ya enlazados a continuación:",
  "a85b1367ca": "El número de teléfono móvil actual “{0}” está enlazado a {1}, puede elegir iniciar sesión con un {2} existente o crear un nuevo {3}:",
  "bf992ce17b": "Crear {0} con otro número de teléfono móvil",
  "395ea04444": "Crear un nuevo {0}",
  "4ce3bb86b3": "El límite de cantidad de {0} para unirse se ha alcanzado",
  "df88c4b7a5": "El número de teléfono móvil actual “{0}” ha alcanzado el límite de enlaces con {1}",
  "78f7dd59ca": "El número de teléfono móvil actual “{0}” está enlazado a los siguientes {1}, puede cambiar y usarlos directamente",
  "8db491a3f8": "Continuar creando un nuevo {0}",
  "83f6d9e1e4": "Intentar de nuevo",
  "1dc5f11612": "O",
  "217d76f53e": "Reportar problemas",
  "b69a6ea62a": "Mantenga presionado el botón izquierdo del mouse y raye para revelar dos escudos",
  "3a31f64800": "Felicitaciones, ha revelado los escudos con éxito<br/>Continúe con la siguiente operación",
  "6a81fcee96": "Cargando",
  "e97877a65d": "Ah, los escudos han desaparecido<br/>Por favor",
  "8d85456145": "He esperado demasiado tiempo<br/>Por favor",
  "77ad847b95": "La red no está funcionando bien<br/>Por favor",
  "dbd1ae3a34": "Has rayado demasiado rápido<br/>Por favor",
  "bd8e05cd53": "Haga clic en el botón para comenzar la verificación inteligente",
  "63d2a8a722": "Verificación exitosa",
  "73141928ad": "La verificación ha fallado, haga clic en el botón para actualizar",
  "04856c5c8a": "Detectando inteligente",
  "52cd9bd26d": "Su operación no está autorizada",
  "fd157e8ea8": "Guía de creación",
  "c6225c5b2b": "Bienvenido a la versión empresarial",
  "e33423fb1e": "Creación exitosa",
  "7b0c035999": "Página de creación exitosa de empresas de Kingsoft Office",
  "85db8faae0": "Instrucciones de uso de la versión empresarial",
  "20591b9b44": "Recuperar el nombre de la empresa",
  "b023d76dc2": "Guía de carga de miembros",
  "e2f454e095": "La empresa de {0}",
  "df466f942b": "Sucursal",
  "26a7b797c4": "Subcentro",
  "5fc82b360b": "Plataforma de servicios de oficina integrada para hacer su trabajo más eficiente",
  "f2e736d52e": "Bienvenido a la versión empresarial",
  "becc41a35b": "Nombre de la empresa",
  "74685cdc58": "Ingrese el nombre de la empresa u organización, de 4 a 100 caracteres",
  "07b55b1907": "Tamaño de la empresa",
  "77b2f763ad": "Por favor, seleccione el tamaño de su empresa",
  "49d2509109": "Menos de 5 personas",
  "8db2c9b74a": "6 - 20 personas",
  "a9fb0cf14a": "21 - 50 personas",
  "0fed41f8d3": "51 - 100 personas",
  "fb33f25a04": "101 - 200 personas",
  "3e3ff0f52e": "201 - 500 personas",
  "cd8b51f634": "501 - 2000 personas",
  "0662fa6eec": "Más de 2000 personas",
  "69334dba1a": "Necesidades de la empresa",
  "840a017f38": "Por favor, seleccione el problema que más desea resolver",
  "f045b05c73": "Por favor, ingrese las necesidades de creación de su empresa",
  "d8efb0b36d": "Otros",
  "adcb8fbb0c": "Número de teléfono habitual",
  "eb1c73e2ca": "Por favor, ingrese su número de teléfono habitual de 11 dígitos",
  "7f276e7dfa": "Crear gratis",
  "c391b3eec1": "Error al enviar el mensaje de texto",
  "54f4cb8fa7": "Mensaje de texto enviado",
  "231eb1fa1e": "Usuario empresarial_{0}",
  "272b0f9d32": "Usuario empresarial",
  "b209a67331": "Error al crear la empresa, actualice la página.",
  "acb08d0cc9": "Tercer paso de la creación de la empresa",
  "83db361f51": "Después de la creación, activar la lógica de redirección",
  "1e930326e3": "handleStep pasar al siguiente paso",
  "184df5c725": "Error en saveForm",
  "736eab3023": "Verificación de envío",
  "2db62dc13c": "Error en la verificación",
  "54fb0afaea": "Verificación exitosa",
  "d39cff3fcf": "Saltar la situación en la que se descubre que se necesita un código de verificación solo al guardar en extremo",
  "305b777ae5": "Error al comprobar el nombre, abrir el mensaje emergente de \"El nombre de la empresa está ocupado\" y almacenar el nombre",
  "e57b6686b2": "Comprobar si el sujeto de la certificación ya está certificado, abrir el mensaje emergente de protección de la certificación y almacenar la información correspondiente del sujeto de la certificación",
  "f7c86f496d": "Nombre de creación repetido || Código de verificación caducado Si hay alguna no aprobación, impedir la ejecución",
  "cb37db4fd4": "Error en handleSubmit",
  "243a569fc4": "Este nombre ya está registrado, utilice otro nombre",
  "196851a3d9": "Usuario empresarial_{0}",
  "0c3a3595ff": "Usuario empresarial",
  "a33b41e0f2": "Error al crear la empresa, actualice la página.",
  "fcce6a7156": "Creación exitosa",
  "5ec6da58a6": "Notificar al cliente",
  "259c9dfa4e": "Lógica de la edición profesional",
  "864156930f": "Lógica de VBA",
  "7824efd172": "Aplicación móvil de Kingsoft Docs",
  "52b6cfaaaf": "Cliente de WPS",
  "c7c51beea9": "Edición educativa",
  "8d054d4986": "Terminal predeterminado",
  "b597e18fb1": "isWps365PcClient y tiene openurl",
  "b0c13de2a0": "isWps365PcClient o no es cliente, tiene openurl",
  "7d0f2ce18c": "isWps365PcClient o no es cliente, tiene openurl, devolución de llamada exitosa",
  "e2c5a07df6": "No es client ni openurl",
  "29e0414d1f": "Devolución de llamada para no ser client ni openurl",
  "60861f7d2a": "autoChange se deja que el equipo comercial realice la conmutación",
  "7c83140d90": "Se crea el estado de visitante, no es necesario pasar por el SDK para cambiar de cuenta (el SDK no admite visitantes), el código ha cambiado correctamente a través de la interfaz",
  "3379b09e59": "Hay openurl y se utiliza href para cambiar",
  "586ff04c22": "Redirección individual",
  "b6c91f218b": "La conmutación con useSuccessSkip ha fallado",
  "47d2f3ba66": "Otros",
  "57551f86ce": "Desencadenar diferentes métodos de redirección según utm_source",
  "64fe3758e2": "Su operación no está autorizada",
  "4da3e1262f": "Se ha creado con éxito. ¡Empecemos el viaje de trabajo empresarial!",
  "c38dfb8c6c": "Crea tu primer equipo",
  "38dddb483b": "Ingresar a la empresa",
  "614d9c91eb": "Invitar a miembros a unirse",
  "97f1eca0aa": "Ingresar a la empresa",
  "13a4939e90": "Invitación para unirse a la empresa",
  "a319e4ae0a": "Invitar a colegas a unirse",
  "12e4da6bba": "Invitar inmediatamente a colegas",
  "bd885380f6": "Error al obtener el enlace de invitación",
  "5e626c4063": "El mensaje de texto se ha enviado",
  "3dc09e7cfd": "Ha alcanzado el límite del número de nombres de empresas que puede solicitar recuperar",
  "48318f41f9": "Invitar a miembros a unirse",
  "45441baac4": "Te invito a unirte a {0} para colaborar",
  "e5847fbd67": "Copiar el enlace e invitar a miembros",
  "23101dd40a": "Estamos personalizando una solución para usted",
  "71bb7e54a8": "Administración de proyectos",
  "aff37c79cc": "Probar la solución seleccionada",
  "a97b174258": "Invita a <color: red>2</> colegas más para unirte y obtén los siguientes beneficios empresariales de forma gratuita",
  "253855849f": "Compartir el enlace de invitación en el grupo de trabajo para invitar a colegas",
  "57b0a2a63f": "Copiar el enlace e invitar a colegas",
  "71c0a37ee1": "Ingresar a la empresa",
  "f848c60e0e": "Invita a <color: red>2</> colegas más para unirte y obtén los siguientes beneficios empresariales de forma gratuita",
  "664e32b4fe": "Ingresar a la empresa desde la página de invitación",
  "872f14403a": "Invitar a colegas a unirse",
  "1880e7deb9": "Invitar inmediatamente a colegas",
  "cc2a9aaf82": "Se ha creado con éxito",
  "02a13e2583": "Invita a <color: red>2</> colegas más para unirte y obtén los siguientes beneficios empresariales de forma gratuita",
  "5d3593cdce": "Error al obtener la información del equipo",
  "c025113ea1": "Error al obtener el enlace de invitación",
  "b83bc1e485": "Invitación a través de enlace",
  "0996ced9f6": "Lo siento, su navegador actual no admite la descarga de este código QR",
  "1e88451e31": "Se ha copiado el enlace de invitación",
  "bb969cabcd": "La copia ha fallado. Inténtelo de nuevo",
  "15e1f79c7a": "Solicitar unirse a la empresa",
  "59c22b4ef8": "Ha recibido un enlace de invitación",
  "0f0b392e60": "Crea tu primer equipo",
  "0437d07c43": "Nombre de la empresa",
  "41800c7bf1": "Ingrese el nombre del creador",
  "1ec5999511": "El nombre del creador no puede exceder 8 caracteres",
  "02da35b4e4": "El nombre del creador solo puede contener caracteres chinos, letras y números",
  "184e9f6616": "Ingrese el número de teléfono",
  "9b587898ba": "Ingrese un número de teléfono con el formato correcto",
  "e68c164a02": "Ingrese su correo electrónico",
  "0b1de22df7": "Ingrese un correo electrónico con el formato correcto",
  "61026181ab": "La licencia de negocio es obligatoria",
  "c3847e604e": "El tamaño del archivo excede 10M, por favor seleccione de nuevo",
  "49450f4ec7": "El formulario de reclamación por nombre repetido es obligatorio",
  "39c3b8fa1d": "El envío ha fallado",
  "3ea44d7963": "La carga se ha realizado con éxito",
  "5b1aa3c2c4": "La carga ha fallado",
  "7e7f81eaa3": "La carga ha fallado, el archivo es mayor de 10m",
  "2ff1913de1": "La carga ha fallado, el archivo debe ser .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "La licencia de negocio es obligatoria",
  "66bda65057": "El tamaño del archivo excede 10M, por favor seleccione de nuevo",
  "8f2305a83d": "El formulario de reclamación por nombre repetido es obligatorio",
  "55ff0c8c6e": "El envío ha fallado",
  "8dad6d950d": "Error al obtener la información de invitación",
  "a5f0ac3a9a": "Se ha creado con éxito",
  "4f1d069770": "Los parámetros utm del acceso a la página de invitación son {0} y name {1}",
  "f9578cfe6d": "Los parámetros utm del acceso de dos pasos son {0} y name {1}",
  "e10d028405": "dos pasos de guía pcoffice creado",
  "8e22e4fcc4": "Se ha copiado el enlace de invitación",
  "3f327f9f37": "La copia ha fallado, inténtelo de nuevo",
  "bd1aecb265": "Cancelar",
  "b6abf9b19a": "Aceptar",
  "e910d9cc0f": "Cancelar",
  "37ab25522d": "Aceptar",
  "196b3eb9cf": "Escanea el código para unirte",
  "2b81c52e20": "Descargar imagen",
  "62152fd9f3": "Invitar por enlace",
  "e0a3725651": "Lo siento, su navegador actual no admite la descarga de este código de barras",
  "8b7883b2c7": "Escanea el código para unirte",
  "9e9a659ed5": "Descargar imagen",
  "0d55065a9a": "Invitar por enlace",
  "487cf6a106": "Lo siento, su navegador actual no admite la descarga de este código de barras",
  "78fd005d1f": "Ingrese el número de teléfono",
  "f909563857": "Crea con este número",
  "a26a19f139": "Cancelar la creación",
  "cc004ac9ee": "Número de teléfono",
  "4df8c3c588": "Ingrese otro número de teléfono para crear una escuela",
  "3151cabb3d": "Ingrese otro número de teléfono para crear una empresa",
  "56098a71eb": "Haga clic en verificación inteligente para enviar el código de verificación",
  "e96ec218e4": "Ingrese el código de verificación de SMS",
  "ce619a0225": "El código de verificación de SMS se envía a",
  "0e9863aaeb": "El código de verificación es incorrecto, inténtelo de nuevo",
  "32dc8629e1": "Reenviar después de segundos",
  "e4eda9add5": "Reenviar",
  "b007977564": "Error al obtener la información de aprobación",
  "d8852ffc9c": "Acceso no administrador",
  "8a733a2574": "Acceso móvil",
  "9e8c152c4f": "Acceso de PC",
  "2265a55e93": "Aceptar el acuerdo de servicio",
  "80dabe5aa3": "Guía de creación",
  "7deee8bf5a": "dos pasos de guía docsWeb creado",
  "69eb501ecb": "Su apelación ha caducado y no se puede acceder",
  "aa1d9d98ad": "No tiene suficientes permisos para acceder",
  "fdf2fe129e": "Crear institución",
  "7f0ca0df6b": "Crear empresa",
  "cc6ac2a93c": "Dos pasos de guía Base mounted",
  "5d6c570bf0": "Dos pasos de guía beforeunload",
  "a4eb8a192d": "Los equipos que todos están creando",
  "4912e16a9d": "El nombre de la empresa ha sido recuperado",
  "41c4e87ef2": "Puede hacer clic en el enlace",
  "5e630930c0": "Volver a crear la empresa",
  "436a563524": "Si ya ha creado una empresa, puede seguir",
  "0b6e7cbe7f": "¿Cómo modificar el nombre de la empresa?",
  "cb7bce0775": "El tutorial para modificar el nombre de la empresa",
  "3feadd3040": "La versión actual es demasiado baja para utilizar la empresa",
  "3cf23de936": "La versión de su software es demasiado baja y la función de empresa no se puede utilizar. Vaya a la tienda de aplicaciones para actualizar la versión del software.",
  "a1c5d5d202": "Entendido",
  "e50183bd00": "Documentos en la nube de WPS",
  "e5031ab679": "Seguridad, sincronización, colaboración",
  "c870026dfc": "Inicio de sesión con WeChat",
  "e7647cd875": "Teléfono o correo electrónico",
  "07b380074b": "Inicio de sesión con QQ",
  "67921724dd": "Otros métodos",
  "254da8a9f5": "La cantidad de empresas para unirse o crear ha alcanzado el límite",
  "3648e4811b": "Ingresar a Documentos de Kingsoft",
  "dcd102b346": "Crear un equipo personalizado",
  "8b9b258cbf": "Ingrese el nombre del equipo aquí",
  "19bb6e0ded": "Los miembros de WPS disfrutan de",
  "2d9fe8d938": "prerrogativas de oficina para ayudarlo a resolver los problemas de documentos en el trabajo diario. ¡Ven y experimenta!",
  "e8c1caa649": "Subir desde el disco local",
  "03641083a3": "Mover desde \"Documentos personales\"",
  "eecd3ab9b5": "Hablar más tarde",
  "13b447b3a8": "Cambiar a otro grupo",
  "3c2fc507fc": "La versión actual es demasiado baja para utilizar la empresa",
  "c3615d8134": "La versión de su software es demasiado baja y la función de empresa no se puede utilizar. Vaya a la página web oficial para actualizar la versión del software.",
  "644a36e05b": "Ir a actualizar",
  "d435105f21": "La cantidad de empresas para unirse o crear ha alcanzado el límite",
  "73a286ceb0": "Ingresar a Documentos de Kingsoft",
  "c2cec645c0": "Cancelar",
  "b5f5b83c0f": "Aceptar",
  "76ec352da5": "Invitar a colegas con código de barras",
  "6a509e4487": "Descargar código de barras",
  "940cc4a546": "No se puede crear la empresa",
  "78b2a62ea5": "Ingresar a una empresa existente o crear una nueva empresa",
  "3a6da7f6f9": "La cantidad de empresas vinculadas al número de teléfono actual ha alcanzado el límite (como máximo se pueden vincular 5 empresas)",
  "93bab52870": "El número de teléfono actual ya está vinculado a una empresa. Puede elegir iniciar sesión en la empresa existente:",
  "ce6e0adaf2": "Puede elegir ingresar a la empresa vinculada a continuación:",
  "1ce200a92b": "Elegir",
  "bb91ef2999": "Crear una nueva empresa",
  "024e4a91e5": "El nombre de la empresa ya está registrado y en uso",
  "eb089a23a0": "El nombre de esta empresa ya está registrado y en uso:",
  "7646558701": "Administrador:",
  "1d9c02bd33": "Fecha de registro:",
  "919fc7805f": "Le recomendamos que intente buscar y contactar a su colega mencionado anteriormente.",
  "0ca71a9344": "También puede crear temporalmente una empresa con otro nombre (se puede cambiar más adelante) y luego presentar una apelación.",
  "e83a244e90": "Haga clic para saber cómo interponer una queja.",
  "d22bedfb21": "Aceptar",
  "907b78b6e5": "Ingrese el nombre del grupo de trabajo o equipo",
  "7195b0ac1e": "Los equipos que es posible que desee crear",
  "60ed4f915e": "Siguiente",
  "f5ba8dfb7b": "Saltar la guía",
  "5c44a3ef68": "Máximo 100 caracteres",
  "130c53fb20": "El nombre no puede contener caracteres ilegales y símbolos especiales /\\;:*?\"<>|%&",
  "e832d41acc": "Saltar la guía de dos pasos",
  "80d9cf7177": "Actualizar la guía de dos pasos",
  "0aebf80435": "Haga clic en el label de la guía de dos pasos",
  "e74f515977": "handleSubmit de la guía de dos pasos",
  "308d2a53c9": "createGroup de la guía de dos pasos",
  "dda2ed7e18": "Error al crear el equipo en la guía de dos pasos",
  "ded3c35500": "Error al crear el equipo",
  "4f18031bc1": "createTemplate de la guía de dos pasos",
  "091e5cefcc": "Error de createTemplate en la guía de dos pasos",
  "58cf4e00f0": "Código de verificación",
  "92abbf0385": "Enviar código de verificación",
  "f0f9976ef9": "Ingrese el número de teléfono móvil",
  "a4ce99b1df": "Código de verificación",
  "39d36e0f9f": "Confirmar",
  "0fd8a01938": "Enviar",
  "9048a4e842": "Número de teléfono móvil",
  "9afa1091eb": "Reenviar",
  "58d787001f": "Ingrese otro número de teléfono móvil para crear una escuela",
  "450905a265": "Ingrese otro número de teléfono móvil para crear una empresa",
  "f7386de3c6": "Selección desplegable",
  "27aa05a92c": "Aceptar el Acuerdo de Servicio",
  "80af61cb57": "Volver a la página anterior",
  "50149b8d4f": "Nombre del solicitante",
  "e6756f8749": "Ingrese su nombre",
  "3cbd51a2b1": "El nombre debe tener al menos 2 caracteres. Ingrese un nombre de 2 a 10 caracteres",
  "4f79b4813f": "El nombre solo admite caracteres chinos, números, letras inglesas y ·",
  "71d3e75983": "Número de teléfono móvil habitual",
  "afe5149035": "Ingrese su número de teléfono móvil habitual",
  "1e9270b50f": "Ingrese su número de teléfono móvil habitual, 11 dígitos",
  "ff5dc98dfb": "Saltar",
  "165be2ab43": "Volver al paso anterior",
  "231d8a335a": "Aceptar el Acuerdo de Servicio",
  "1cad008ffc": "El nombre de la empresa {0} ya está registrado. Utilice otro nombre",
  "c6e274fcab": "Confirmación del acuerdo",
  "b9352504bb": "Cerrar la ventana emergente del acuerdo",
  "8409e99ad0": "Abrir la ventana emergente del acuerdo",
  "1593c6dd95": "Enviar",
  "4f44a9de22": "Activar la verificación de SMS",
  "26b70c68b8": "Saltar y entrar directamente a la empresa",
  "a8bebcb302": "Volver a la página anterior",
  "c800b4fec5": "Base Montada de la página de invitación",
  "38b396d5b0": "docsWeb Montado de la página de invitación",
  "2eb7f9a9f1": "Su queja se ha enviado con éxito",
  "2c6f3590fb": "Es probable que enviemos el resultado del trámite a su correo electrónico dentro de 3 días hábiles. ",
  "2ea3eff708": "Tenga en cuenta que revise su correo.",
  "53acfba22c": "Invitar a colegas inmediatamente",
  "4e6d282f4f": "Invitación para unirse a la empresa",
  "5f72f4b936": "Invitar a colegas inmediatamente",
  "e5383077ba": "Recuperar el nombre de la empresa",
  "06e3fa2350": "Según la consulta,",
  "653a263b5e": "El creador de",
  "769f57269f": "El número de teléfono móvil del creador es",
  "09a224695e": "Confirme si el creador de esta empresa es su colega",
  "3beda6c149": "· Si es su colega, puede contactarlo",
  "5c74dd10d1": "Modifique el nombre de la empresa o transfiera el super administrador.",
  "da504edb0f": "· Si no es su colega, puede hacer clic en el botón inferior para continuar recuperando el nombre de la empresa.",
  "39194faaf1": "Continuar recuperando el nombre de la empresa",
  "e22b829e90": "Copia exitosa",
  "6e1b44752a": "Valor de TXT",
  "79881b1d7a": "Invitar a un colega inmediatamente",
  "a5344a45f9": "Haga clic en la esquina superior derecha y seleccione [Enviar a un amigo]",
  "a4954a5b08": "Invitar a un colega inmediatamente",
  "8e3a1625fb": "Recuperar el nombre de la empresa",
  "bf8b8c7005": "Subir la licencia de negocio de la empresa",
  "bfd44a66c9": "Haga clic para seleccionar",
  "d503f20925": "Por favor, suba un escaneo o una foto de la licencia de negocio de la empresa",
  "cbebe043c5": "Se admiten formatos JPG, JPEG, PNG, BMP y PDF, y el tamaño no debe exceder 10 MB.",
  "9650b96d7d": "Subir el formulario de reclamación de nombre duplicado",
  "c3b8ae46d3": "Por favor, suba un escaneo o una foto del formulario de reclamación de nombre duplicado",
  "9e325a9e09": "Descargar el modelo del formulario de información",
  "a4711aae88": "Enviar solicitud",
  "3a5cc1441e": "En proceso de certificación...",
  "0bd7bf8511": "Actualmente no podemos verificar su dominio. Es posible que tenga que esperar un tiempo más para que el proveedor de alojamiento de dominios actualice su información. Si después de un tiempo no hay respuesta, intente verificar de nuevo o cambie el dominio.",
  "fae48d554b": "Verificando el dominio",
  "5e1779a0ca": "Registro de verificación, puede cerrar esta página y volver a revisar más tarde.",
  "ca85f8b836": "Bienvenido a la versión empresarial",
  "2570e0f00b": "Error de inicio de sesión",
  "40d16a007e": "Su cuenta personal se ha enlazado automáticamente",
  "81376b92e4": "Modo de inicio de sesión de {0}, inicie sesión nuevamente para cambiar a la cuenta empresarial.",
  "ba679ba739": "Entendido, ir a iniciar sesión",
  "c05f64c6c6": "Después de {0}, se dirige automáticamente al inicio de sesión",
  "c329ccef3a": "Error de inicio de sesión",
  "e370f9afb1": "Su cuenta personal se ha enlazado automáticamente",
  "410cf42585": "Modo de inicio de sesión, inicie sesión nuevamente para cambiar a la cuenta empresarial.",
  "062d48aece": "Entendido, ir a iniciar sesión",
  "95a105d412": "Después de, se dirige automáticamente al inicio de sesión",
  "2d000d5a6d": "Enviar un enlace de compartir a los miembros. Los miembros pueden solicitar unirse después de abrirlo",
  "8861b6e90d": "Ingresar a la empresa",
  "25b9f72fda": "Error de parámetros de página",
  "1c76123efc": "Error al obtener el enlace de invitación",
  "6caba48b76": "Saltar",
  "f66379c650": "Error de parámetros de página",
  "c45021de2a": "Error al crear",
  "011d470126": "La plataforma protege constantemente la seguridad de su información",
  "f1a44d9151": "La plataforma ha obtenido los certificados ISO27001 e ISO27701 promulgados por BSI internacional y ha superado la evaluación de la calificación de seguridad del nivel tres nacional--",
  "255ea5dff7": "Libro Blanco de Seguridad",
  "bb55b124f2": "Crear una presentación de la empresa",
  "61e24974a3": "Crear contenido de la estrategia de adquisición de la empresa",
  "bfdf78febe": "Completar los datos en el siguiente paso",
  "c4aa2d2d60": "Ingrese el nombre del grupo de trabajo o del proyecto",
  "b69765ab64": "Equipos que todos están creando",
  "9657d9408b": "Cambiar a otro grupo",
  "e21da8c16a": "Siguiente paso",
  "224ef5cc9f": "Saltar la guía",
  "641f58c8f6": "La empresa actual no permite que los miembros creen equipos. Por favor, contacte al administrador para crear uno",
  "efea622752": "Copiar el enlace e invitar a colegas",
  "fd5b40a9fd": "Te invito a unirte a 「{0}」 para trabajar en colaboración",
  "b04dd2f10a": "El enlace de invitación se ha copiado",
  "d1606a1b1a": "La copia ha fallado. Inténtelo de nuevo",
  "0d59f3db83": "Ingrese el departamento o el equipo del proyecto, como \"Departamento de Ventas\"",
  "9429513d34": "No se necesita guía",
  "b54a20b1ff": "La creación ha fallado",
  "093fa0fb74": "Autenticación de inicio de sesión en proceso...",
  "b383b136f4": "Inicialización del proyecto de la empresa",
  "b6b21b388b": "El nombre de la empresa ya está registrado y en uso",
  "285dc68c10": "El nombre de la empresa ya está registrado y en uso:",
  "1bf685b89d": "Administrador:",
  "7b4297edcc": "Fecha de registro:",
  "fa51ea19fc": "Le recomendamos que intente buscar y contactar a su colega mencionado anteriormente.",
  "e3678a996d": "También puede usar temporalmente otro nombre para crear la empresa (puede cambiarse más adelante) y luego enviar una solicitud de apelación.",
  "5969bc8071": "De acuerdo",
  "ba4cf699df": "Recuperar el nombre de la empresa",
  "afecee4eb4": "Su nombre",
  "a8bdebc614": "Por favor, ingrese su nombre",
  "5bbeb38a66": "Número de teléfono",
  "b4f7b44b7a": "Por favor, ingrese su número de teléfono",
  "cac2913686": "Correo electrónico",
  "23d3bb3a42": "Por favor, ingrese su correo electrónico",
  "ea106a393c": "Subir la licencia de negocio de la empresa",
  "f74131d71e": "Haga clic para seleccionar",
  "53749c51c5": "Por favor, subir un escaneo o una foto de la licencia de negocio de la empresa",
  "c00f2ea171": "Se admiten formatos JPG, JPEG, PNG, BMP, PDF y el tamaño no debe exceder 10 MB.",
  "57ec07fa97": "Subir el formulario de solicitud de apelación por nombre repetido",
  "8eb0606e94": "Por favor, subir un escaneo o una foto del formulario de solicitud de apelación por nombre repetido",
  "f59e76c0b0": "Descargar el modelo del formulario de información",
  "030bd26fa4": "Enviar solicitud",
  "0a602dc727": "Almacenamiento seguro de datos",
  "9138f28acf": "Colaboración de archivo compartido",
  "b3a306cf90": "Legalidad y estandarización",
  "973c53f725": "Se recomienda modificar el nombre. Después de registrarse, puede enviar la certificación de la institución y actualizar el nombre",
  "f886f5e92f": "Se recomienda modificar el nombre. Después de registrarse, puede enviar la certificación de la empresa y actualizar el nombre",
  "b8051702a3": "El nombre contiene palabras sensibles. Ajuste el nombre o contacte a los servicios de atención al cliente",
  "d73881f7d4": "El nombre de la empresa está protegido",
  "dc7e58e320": "El nombre de la empresa está protegido. Antes de usarlo, es necesario verificar la información del sujeto. Se recomienda modificar el nombre de la empresa o usar ese nombre después de registrarse y pasar la certificación de la empresa.",
  "20c3bc070c": "Confirmar",
  "c4278e5f28": "No tiene suficientes permisos",
  "9217efae21": "La cuenta con la que ha iniciado sesión no tiene permiso para crear. Comuníquese con el personal de ventas para resolverlo",
  "52ff08f2ad": "El nombre de la institución está protegido. Ajuste el nombre de la empresa",
  "79386ae280": "Ingrese el código de verificación de 6 dígitos",
  "d7b2c5a41b": "El código de verificación se ha enviado a",
  "ce2e1c26f7": "(Válido dentro de 10 minutos)",
  "59d338903f": "Puede obtener el código de verificación de nuevo en {0} segundos",
  "5aadd14136": "Obtener código de verificación de nuevo",
  "90f5c93432": "Este nombre ya está registrado",
  "1677072f4a": "Puede agregar más información o usar otro nombre para registrarse",
  "3b8459fb1e": "Llenado rápido:",
  "6f38edbcb1": "Registrarse con este nombre",
  "8406c81e2d": "Sucursal",
  "29d323fa85": "Subcentro",
  "4f0e806e02": "Departamento de Finanzas",
  "3f935efb6b": "Aceptar el Acuerdo de Servicio",
  "b42241be05": "No por ahora",
  "99de4b33b7": "Aceptar",
  "7f867e7395": "Crear una empresa con otro número de teléfono",
  "0d51a8f7a6": "Continuar creando",
  "8bdaecf2e5": "Ingrese su número de teléfono",
  "565ae60c8a": "Ingrese su nombre",
  "f76e06d0e7": "Ingrese su número de teléfono",
  "7b0fca5255": "Ingrese el código de verificación",
  "68026d2d25": "Bienvenido a la versión empresarial",
  "d25b5541be": "Crear de forma gratuita",
  "32cfd73733": "Ingrese el nombre del equipo, empresa u organización",
  "4cf83dc4a0": "Cree en un minuto y colabore eficientemente con sus colegas",
  "d320d37116": "Crear un equipo/empresa de forma gratuita",
  "c54b475dd2": "Acuerdo de usuario",
  "190d54e616": "Empresa de {0}",
  "8c1b768ac4": "Fallo en la verificación inteligente",
  "d74eab0f35": "La información ingresada para el nombre de su empresa no cumple con las normas de la plataforma. Intente de nuevo después de realizar los cambios",
  "0f3d62dd4f": "La información ingresada para su nombre no cumple con las normas de la plataforma. Intente de nuevo después de realizar los cambios",
  "647cf2211b": "No se admite la creación con el número de teléfono actual. Cambie el número de teléfono",
  "b63d96cdae": "La información ingresada no cumple con las normas de la plataforma. Intente de nuevo después de realizar los cambios",
  "2dbbe8e43f": "No se admite la creación con el número de teléfono actual. Intente de nuevo después de realizar los cambios",
  "b18abc5de6": "No hay número de teléfono vinculado",
  "f5233dae6f": "Cree con otro número de teléfono",
  "4167c8b88d": "El número de teléfono actual puede tener las siguientes situaciones. Intente crear con otro número de teléfono. Si tiene alguna pregunta, comuníquese con el servicio al cliente.",
  "a8a2433c4d": "Agregue mediante código de escaneo de WeChat y consulte al servicio al cliente",
  "444a639c09": "Lo entiendo",
  "69a097057f": "El número de teléfono actual pertenece al segmento de operador virtual <#BB2726>",
  "4370b06fd0": "El número de teléfono actual tiene <#BB2726> un comportamiento de uso anormal <#BB2726>",
  "8c49e1dc4a": "Se requiere una verificación de ser humano",
  "4b8ba7d8cc": "Plataforma de Productividad de Nueva Calidad Empresarial",
  "81be771e17": "🎉¡Empresa creada con éxito! Completa la información para obtener servicios exclusivos",
  "461125b057": "Puede gestionar documentos y materiales en el equipo. Los miembros del equipo pueden ver fácilmente y también se pueden establecer permisos de edición/descarga para garantizar la seguridad de los datos",
  "c3eb25029b": "Tamaño de la empresa/equipo",
  "049f8401ec": "Menos de 5 personas",
  "c81896349e": "De 6 a 20 personas",
  "7357daac4e": "De 21 a 50 personas",
  "f0e65a0a29": "De 51 a 100 personas",
  "b9fac8204a": "De 101 a 200 personas",
  "62d73dddaf": "De 201 a 500 personas",
  "3bcdaf7160": "De 501 a 2000 personas",
  "ab0b2333fe": "Más de 2000 personas",
  "4f756eedc8": "Tu rol es",
  "3ba0b502c3": "Gerente General",
  "702099cc72": "Finanzas",
  "843b603162": "Compras",
  "8b414a9b44": "Recursos Humanos/Administración",
  "92486b2908": "Ventas",
  "ac4e7fb063": "¿Tiene su organización presupuesto/plan de compra de software de oficina?",
  "37634c72dc": "Dentro de 6 meses",
  "bd94b6deec": "Dentro de 1 año",
  "713f4aad5c": "Considerándolo",
  "c5ea095a4d": "Sin planes actualmente",
  "2409099a69": "Crear Un Equipo, Invitar Miembros Para Colaborar Juntos",
  "9d27dc2d90": "Puede ingresar el nombre del equipo al que pertenece o el proyecto de interés reciente",
  "de19c8509a": "Posiblemente quiera crear:",
  "1a84699223": "Departamento de Ventas",
  "efab59502b": "Departamento de Productos",
  "7e599b3713": "Departamento de Operaciones del Sur",
  "bf494779c2": "Departamento de Compras",
  "f3a60ab34d": "Departamento de Administración",
  "bbc50c1ac8": "Departamento de Finanzas del Norte",
  "32629e3dac": "Departamento de Finanzas de Productos",
  "5524d354ba": "Departamento de IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>¡Has desbloqueado beneficios para principiantes!</span> Invita a 3 personas más para obtener <span style='color: rgb(206,131,62);'>4T de espacio y beneficios de WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Has desbloqueado el límite de 50 personas y 4G de carga máxima por archivo</span>. Continúa invitando a 3 personas más para desbloquear 30 días de WPS AI y 4T de espacio con beneficios increíbles",
  "136c26d941": "Copie el enlace a continuación para invitar a miembros a unirse",
  "3de5c12558": "Copie el enlace para invitar a colegas",
  "a5d64b14f3": "Guía de Información Empresarial",
  "b8f2492701": "Recopilación de Información Empresarial",
  "1f9d053dc0": "Crear plantilla de equipo",
  "0e83c79a88": "Invitar miembros",
  "821fc1906a": "Entrar en la Empresa",
  "463e14ae9c": "Seleccione un equipo",
  "690f0cdb9e": "Icono Completado",
  "c340522a17": "Paso Anterior",
  "f9355c72ef": "Omitir",
  "bd6c09ebbb": "Siguiente",
  "2a2603cd3f": "Envíe la invitación a su colega escaneando el código",
  "411e64907a": "Copiar",
  "b0d988cf23": "Descargar",
  "e3c0b650ac": "Copiado",
  "713ac624b4": "Bienvenido a WPS 365",
  "b8fff97849": "Elemento de destino no válido",
  "02acdcf296": "Error al convertir html2canvas, no se generó el canvas",
  "a76988c496": "Error al convertir el canvas a blob",
  "af89584edf": "API del portapapeles no disponible",
  "f90263bbde": "Error al copiar imagen",
  "71b05319da": "Error al convertir html a canvas",
  "38852999fe": "Error al guardar información",
  "4a4c621d07": "Error al crear un equipo, por favor intente nuevamente más tarde",
  "d239a23994": "La página actual está limitada a cuentas empresariales. Por favor, inicie sesión con una cuenta empresarial.",
  "d93bfb7fb9": "Por favor, ingrese el contenido",
  "42b81a66c4": "La longitud debe estar entre 2 y 100 caracteres",
  "76d33733db": "No puede contener caracteres especiales como / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "Ir a probar",
  "b25233cba0": "Colaboración de documentos + Mensajería instantánea, inicia una nueva forma de trabajo eficiente",
  "f0e563652d": "Iniciar Chat De Colaboración, Compartir Documentos De Forma Segura Y Conveniente",
  "1e484cce68": "Lingxi AI Asistente, Un Asistente Inteligente Nacido Para El Trabajo",
  "e338385bc9": "Oficina Office Inteligente Nativa, Integra Profundamente IA Y Software De Oficina, Para Que Todos Tengan Un Asistente De IA",
  "7ae1f3b1c6": "Importación de archivo(s) completada, puede ver los resultados en 'Mis AirPages'",
  "85db2a024a": "Error en la importación de archivo(s), por favor intente de nuevo más tarde",
  "9ff74c802a": "Descargar versión para chip Intel",
  "ab44928f02": "Descargar versión para chip Apple",
  "a08d937c38": "Subiendo archivo(s), podrá verlos en 'Mis AirPages' una vez completado",
  "68db1829fa": "Solo se admite la importación desde cuentas personales, por favor inicie sesión en su cuenta personal e intente nuevamente.",
  "1185a7c7ab": "Menos de 20 personas",
  "e2bcc252c9": "21-300 personas",
  "3c4842f1ea": "301-1000 personas",
  "1bbee64cfa": "Más de 1000 personas",
  "388ff4a035": "Profesor",
  "d341b1d794": "Estudiante",
  "bfb2ee4148": "Otros",
  "f6450c3f31": "Gestión de proyectos",
  "b87fd33a0d": "Plan anual",
  "0dd45a1c14": "Gestión del rendimiento de empleados",
  "67fa01cac6": "Actividades de marketing",
  "6dd82cc031": "Reclutamiento de empleados",
  "a7edaed91d": "Materiales de enseñanza",
  "bf12b7efb0": "Gestión del plan de enseñanza",
  "c35ae8f358": "Documentación del producto",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Hoja Multi-Dimensional, Visualiza y Construye Sistemas de Negocios Personalizados",
  "72286d5519": "👏Plantillas recomendadas",
  "0bc00ee949": "Gestión de Defectos de Requisitos",
  "e22f3d56f7": "Gestión de Creación de Contenidos",
  "dd439de3dd": "Sistema de Gestión de Clientes",
  "fbb2bbf82e": "Plan de Estudio",
  "0645b908bc": "Consulta de Nómina",
  "813b3d3d7e": "Gestión de OKR",
  "918e33d5bd": "Crear con Un Clic",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importa documentos comunes para un uso más conveniente",
  "c58f28713c": "Importar Desde el Dispositivo",
  "9d6a0a4370": "Soporta Formatos Comunes de Office",
  "54c48aee85": "Seleccionar documentos",
  "c5b593e452": "Importar Desde Cuenta Personal",
  "4bdcd9d4c5": "Importa Documentos, Equipos y Carpetas de Cuenta Personal con Un Clic",
  "99b2968905": "Importación Autorizada",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Descarga el cliente de WPS Teams",
  "fe46574227": "Colaboración en Documentos + Mensajería Instantánea, Nueva Forma de Trabajo Eficiente",
  "beefe5a09b": "Descargar Ahora",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Configuraciones de seguridad enriquecidas para garantizar la seguridad de los datos",
  "b4e70dbeab": "Los años de experiencia en seguridad de documentos de WPS aseguran que los datos críticos de la empresa no se filtren",
  "42dc772619": "Archivo es demasiado grande, por favor intente importar más tarde en la página principal",
  "a052564e47": "Error de creación: Por favor inténtalo de nuevo más tarde",
  "790d0c428c": "Entrar a Workbench"
}